import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class StudentsResolver {
  resolveAllStudentsList$(
    actions: {
      studentLoadAction;
      loadedStatusSelector;
      studentSelector;
    },
    currentSchool,
    store,
  ): Promise<Observable<any>> {
    const { studentLoadAction, loadedStatusSelector, studentSelector } = actions;
    const payload = { schoolId: currentSchool._id };
    const destroy$: Subject<boolean> = new Subject<boolean>();
    return new Promise(resolve => {
      store
        .select(loadedStatusSelector)
        .pipe(takeUntil(destroy$))
        .subscribe(loaded => {
          if (!loaded) store.dispatch(new studentLoadAction(payload));
          if (loaded) {
            const dashboardStudents$ = store.select(studentSelector);
            destroy$.next(true);
            destroy$.unsubscribe();
            resolve(dashboardStudents$);
          }
        });
    });
  }
}
